const alert = {
  Alert: {
    variants: {
      custom: {
        container: {
          color: 'black',
          bg: '#FFDDE5',
          fontSize: '14px',
          border: '1px solid #CF0031',
          top: '82px'
        }
      },
      customInfo: {
        container: {
          color: 'black',
          bg: 'linear-gradient(181.08deg, rgba(232, 224, 249, 0.7) -27.55%, rgba(232, 224, 249, 0) 205%), #FFFFFF;',
          fontSize: '14px',
          border: '1px solid #9E8ABD',
          top: '82px'
        }
      }
    }
  }
}

export default alert
